/** 默认回退首页（返回栈失效 / navigateBack 失败时） */
export const DEFAULT_HOME_URL = '/pages/home/index';

/**
 * 优先返回上一页；无历史或返回失败时 reLaunch 到首页（或自定义兜底页）
 */
export const navigateBackOrHome = (fallbackUrl: string = DEFAULT_HOME_URL) => {
  let stackLen = 0;
  try {
    stackLen = getCurrentPages()?.length || 0;
  } catch (_) {
    stackLen = 0;
  }

  if (stackLen > 1) {
    uni.navigateBack({
      delta: 1,
      fail: () => {
        uni.reLaunch({ url: fallbackUrl });
      },
    });
    return;
  }

  uni.reLaunch({ url: fallbackUrl });
};
